module.exports = __webpack_public_path__ + "components/rewards/panda-optics/static/logo-fb7d1c776f00cd7fe78353ce11b6d227.jpg";